import { PageMeta } from '@/components/ui/PageMeta';
import { LegalDocumentView } from '@/components/legal/LegalDocumentView';

export function PrivacyPolicyPage() {
  return (
    <>
      <PageMeta
        title="Política de Privacidade | Operax"
        description="Como a Operax trata dados pessoais: LGPD e WhatsApp Business Platform."
      />
      <LegalDocumentView code="privacy_policy" fallbackTitle="Política de Privacidade" />
    </>
  );
}
